import styled, { css } from "styled-components";
import { Box } from "../../../UI/Box";

export const Wrapper = styled(Box)`
  position: relative;
  z-index: 12;
  padding: 2rem 0 0 0;
  button {
    max-width: 300px;
    margin: auto;
  }
`

export const TaskContainer = styled(Box)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  h3 {
    color: #fff;
    text-align: center;
    font-feature-settings: 'ss01' on;
    font-family: 'Space Grotesk';
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px; /* 104.167% */
    margin: 0 auto;
    max-width: 434px;
  }
  span.description {
    color: #fff;
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-feature-settings: 'dlig' on, 'ss01' on;
    font-family: 'Space Grotesk';
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 140% */
    letter-spacing: -0.8px;
  }
  @media screen and (max-width: 1000px) {
    h3 {
      font-size: 1.75rem;
      line-height: 2rem;
    }
    span.description {
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }
`

export const ProgressContainer = styled(Box)`
  margin-top: 5rem;
  padding: 5px 15px;
  background: #030B11;
`

const Bar = styled.div<{
  isFilled?: boolean
}>`
  width: 100%;
  height: 5px;
  ${(props) =>
    props.isFilled
      ? css`
          background: ${({ theme }) => theme.colors.brandPrimary};
        `
      : css`
          background: #3a5250;
        `}
`

const ProgressBox = styled(Box)`
  & > :first-child {
    border-radius: 5px 0 0 5px;
  }

  & > :last-child {
    border-radius: 0 5px 5px 0;
  }
`

export const ProgressBar = ({
  length,
  filled,
}: {
  length: number
  filled: number
}) => {
  return (
    <ProgressBox g={10} marginTop={6}>
      {Array(length)
        .fill(0)
        .map((_, index) => (
          <Bar key={index} isFilled={index < filled} />
        ))}
    </ProgressBox>
  )
}
